import { compose } from 'lodash/fp';
import { FileInput, getFile } from '../common';
import { map as emap } from 'fp-ts/lib/Either';
import { pathOr } from 'rambda';

// TODO test className file from SaveRequest

export function UploadFile({
  title,
  file,
  fileName,
  onImport,
  className,
}: {
  title: string;
  file: File | undefined;
  fileName: string | undefined;
  onImport: (file: File) => void;
  className?: string;
}) {
  return (
    <FileInput
      title={title}
      onChange={compose(
        emap(
          compose(onImport, file => {
            return file;
          })
        ),
        getFile
      )}
      filename={pathOr('', 'name')(file) || fileName || ''}
      // className={className}
    />
  );
}
